module.exports = __webpack_public_path__ + "img/GAME_CARDPAIR.1fc84c85.jpg";